const KR = 'kr';

export const addSuffixToNumber = (number: number, suffix: string = KR) => `${number} ${suffix}`;
